/* ==========================================================================
   FOOTBALL-THEME :: Jersey multi-team filters (tag-path mode).

   Shopify hides native collection filters on collections with more than 5,000
   products. The jersey collection is ~5,096, so Clubs / Nations are multi-
   select checkboxes here and the grid is merged in the browser from the same
   tag paths the single-select bar already uses.

   URL shape:
     /collections/jerseys/barcelona+home?fs_teams=barcelona,real-madrid
   The first team is in the path (server-rendered fallback); fs_teams holds all
   selected teams. Kit / League / Edition stay single-select and AND with the
   team set. Paging and sorting are delegated to assets/football-pager.js.
   ========================================================================== */

(function () {
  /* This script is loaded from the jersey club tile row, before the dock
     spring script. Seed the open drawer there so a full-page team change
     reopens the panel the customer was using (the live dock script predates
     the multi-team mode and does not read this itself). */
  if (!window.__fsMultiTeamBoot) {
    try {
      var storedOpen = sessionStorage.getItem('fs-fdock-open');
      if (storedOpen) window.__fsFdockOpenRow = storedOpen;
    } catch (e) {}
  }
  if (window.__fsMultiTeamBoot) return;
  window.__fsMultiTeamBoot = true;

  var dock = document.querySelector('[data-fs-fdock]');
  if (!dock) return;

  var collectionUrl = (dock.getAttribute('data-fs-collection-url') || '').replace(/\/$/, '');
  if (!collectionUrl) {
    var segments = window.location.pathname.split('/').filter(Boolean);
    var collectionsIndex = segments.indexOf('collections');
    if (collectionsIndex !== -1 && segments[collectionsIndex + 1]) {
      collectionUrl = '/' + segments.slice(0, collectionsIndex + 2).join('/');
    }
  }
  var teamBoxes = Array.prototype.slice.call(dock.querySelectorAll('[data-fs-team-toggle]'));
  if (!collectionUrl || !teamBoxes.length) return;

  var TEAM_PARAM = 'fs_teams';
  var teamValues = new Set(teamBoxes.map(function (box) { return box.value; }));
  var leagueValues = new Set(
    Array.prototype.map.call(
      dock.querySelectorAll('[data-fs-fdock-panel="league"] [data-fs-tile-value]'),
      function (el) { return el.getAttribute('data-fs-tile-value'); }
    )
  );

  var gridSectionId = '';
  var pagerRow = document.querySelector('[data-fs-pager-row="top"]');
  var grid = document.getElementById('product-grid');
  if (pagerRow) gridSectionId = pagerRow.getAttribute('data-section-id') || '';
  if (!gridSectionId && grid) gridSectionId = grid.getAttribute('data-id') || '';
  var serverPer = 16;
  if (pagerRow) serverPer = parseInt(pagerRow.getAttribute('data-server-per-page'), 10) || 16;

  var cacheState = { key: '', pages: {}, counts: {}, inFlight: {} };

  function collectionPath() {
    var path = collectionUrl;
    try {
      path = new URL(collectionUrl, window.location.origin).pathname;
    } catch (e) {}
    return path.replace(/\/$/, '');
  }

  function tagsFromPath(pathname) {
    var base = collectionPath();
    if (pathname.indexOf(base + '/') !== 0) return [];
    var rest = pathname.slice(base.length + 1).split('/')[0];
    return rest
      .split('+')
      .filter(Boolean)
      .map(function (tag) {
        try { return decodeURIComponent(tag); } catch (e) { return tag; }
      });
  }

  function urlTeams() {
    var raw = new URLSearchParams(window.location.search).get(TEAM_PARAM) || '';
    return raw
      .split(',')
      .map(function (value) { return value.trim(); })
      .filter(Boolean);
  }

  function pathTeam() {
    var tags = tagsFromPath(window.location.pathname);
    for (var i = 0; i < tags.length; i++) {
      if (teamValues.has(tags[i])) return tags[i];
    }
    return '';
  }

  function selectedTeams() {
    var teams = urlTeams();
    var path = pathTeam();
    if (!teams.length) {
      if (path) teams = [path];
    } else if (path && teams.indexOf(path) === -1) {
      teams.unshift(path);
    }
    var seen = {};
    return teams.filter(function (team) {
      if (!teamValues.has(team) || seen[team]) return false;
      seen[team] = true;
      return true;
    });
  }

  var currentTeams = selectedTeams();

  function active() {
    return currentTeams.length > 1;
  }

  function baseTags() {
    return tagsFromPath(window.location.pathname).filter(function (tag) {
      return !teamValues.has(tag);
    });
  }

  function sortValue() {
    var sort = new URLSearchParams(window.location.search).get('sort_by') || '';
    return sort === 'manual' ? '' : sort;
  }

  function teamLeague(value) {
    for (var i = 0; i < teamBoxes.length; i++) {
      if (teamBoxes[i].value === value) {
        return teamBoxes[i].getAttribute('data-fs-team-league') || '';
      }
    }
    return '';
  }

  function teamLabel(value) {
    for (var i = 0; i < teamBoxes.length; i++) {
      if (teamBoxes[i].value === value) {
        var item = teamBoxes[i].closest('[data-fs-tile-item]');
        var label = item && item.querySelector('.fs-tile__label');
        return label ? label.textContent.trim() : value;
      }
    }
    return value;
  }

  function buildUrl(teams, tags) {
    var cleanTeams = (teams || []).filter(function (team) { return teamValues.has(team); });
    var cleanTags = (tags || []).filter(function (tag) { return !teamValues.has(tag); });
    var parts = [];
    if (cleanTeams.length) parts.push(cleanTeams[0]);
    parts = parts.concat(cleanTags);

    var url = collectionUrl;
    if (parts.length) {
      url += '/' + parts.map(function (part) { return encodeURIComponent(part); }).join('+');
    }

    var params = new URLSearchParams();
    if (cleanTeams.length > 1) params.set(TEAM_PARAM, cleanTeams.join(','));
    var sort = sortValue();
    if (sort) params.set('sort_by', sort);
    var query = params.toString();
    return query ? url + '?' + query : url;
  }

  function rememberOpenRow() {
    try {
      if (window.__fsFdockOpenRow) sessionStorage.setItem('fs-fdock-open', window.__fsFdockOpenRow);
    } catch (e) {}
  }

  function navigate(url) {
    rememberOpenRow();
    window.location.assign(url);
  }

  function toggleTeam(box) {
    var value = box.value;
    var teams = selectedTeams();
    var checked = box.checked;
    var tags = baseTags();
    var activeLeague = tags.find(function (tag) { return leagueValues.has(tag); });
    var league = box.getAttribute('data-fs-team-league') || '';

    if (checked) {
      if (teams.indexOf(value) === -1) teams.push(value);
      if (activeLeague && league !== activeLeague) {
        tags = tags.filter(function (tag) { return tag !== activeLeague; });
      }
    } else {
      teams = teams.filter(function (team) { return team !== value; });
    }

    navigate(buildUrl(teams, tags));
  }

  /* Rebuild a team set when a chip is removed. */
  function removeTeamFromChips(value) {
    var teams = selectedTeams().filter(function (team) { return team !== value; });
    navigate(buildUrl(teams, baseTags()));
  }

  function removeFilterValue(value) {
    if (teamValues.has(value)) {
      removeTeamFromChips(value);
      return;
    }
    var tags = baseTags().filter(function (tag) { return tag !== value; });
    navigate(buildUrl(selectedTeams(), tags));
  }

  function applyLeague(value, selected) {
    var teams = selectedTeams();
    var tags = baseTags().filter(function (tag) { return !leagueValues.has(tag); });

    if (selected) {
      navigate(buildUrl(teams, tags));
      return;
    }

    tags.push(value);
    if (teams.length) {
      var matching = teams.filter(function (team) { return teamLeague(team) === value; });
      teams = matching;
    }
    navigate(buildUrl(teams, tags));
  }

  function handleFilterLink(link) {
    if (link.hasAttribute('data-fs-clear-all') || link.classList.contains('fs-fdock__clear')) {
      var sort = sortValue();
      navigate(collectionUrl + (sort ? '?sort_by=' + encodeURIComponent(sort) : ''));
      return;
    }

    var chipValue = link.getAttribute('data-fs-chip-value');
    if (chipValue) {
      removeFilterValue(chipValue);
      return;
    }

    var item = link.closest('[data-fs-tile-item]');
    if (!item) {
      var href = link.getAttribute('href') || '';
      try {
        var url = new URL(href, window.location.origin);
        var hrefTags = tagsFromPath(url.pathname);
        navigate(buildUrl(selectedTeams(), hrefTags.filter(function (tag) { return !teamValues.has(tag); })));
      } catch (e) {
        window.location.assign(href);
      }
      return;
    }

    var row = item.getAttribute('data-fs-tile-row');
    var value = item.getAttribute('data-fs-tile-value');

    if (row === 'league') {
      var selected = item.classList.contains('is-selected') || link.getAttribute('aria-current') === 'true';
      applyLeague(value, selected);
      return;
    }

    try {
      var target = new URL(link.getAttribute('href'), window.location.origin);
      var targetTags = tagsFromPath(target.pathname).filter(function (tag) {
        return !teamValues.has(tag);
      });
      navigate(buildUrl(selectedTeams(), targetTags));
    } catch (e) {
      navigate(buildUrl(selectedTeams(), baseTags()));
    }
  }

  function markTiles() {
    teamBoxes.forEach(function (box) {
      var selected = currentTeams.indexOf(box.value) !== -1;
      box.checked = selected;
      var item = box.closest('[data-fs-tile-item]');
      if (item) item.classList.toggle('is-selected', selected);
    });

    ['club', 'nation'].forEach(function (row) {
      var panel = dock.querySelector('[data-fs-fdock-panel="' + row + '"]');
      var tab = dock.querySelector('[data-fs-fdock-tab="' + row + '"]');
      if (!panel || !tab) return;
      var count = panel.querySelectorAll('[data-fs-team-toggle]:checked').length;
      var badge = tab.querySelector('.fs-fdock__count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'fs-fdock__count';
          tab.appendChild(badge);
        }
        badge.textContent = String(count);
        tab.classList.add('has-active');
      } else {
        if (badge) badge.remove();
        tab.classList.remove('has-active');
      }
    });
  }

  function addExtraChips() {
    var chips = dock.querySelector('.fs-fdock__chips');
    if (!chips) return;
    var template = chips.querySelector('[data-fs-chip-value]');
    var clear = chips.querySelector('[data-fs-clear-all]');

    currentTeams.forEach(function (team) {
      var existing = Array.prototype.find.call(
        chips.querySelectorAll('[data-fs-chip-value]'),
        function (chip) { return chip.getAttribute('data-fs-chip-value') === team; }
      );
      if (existing) return;

      var label = teamLabel(team);
      var chip = template ? template.cloneNode(true) : document.createElement('a');
      chip.className = 'fs-fdock__chip';
      chip.setAttribute('href', buildUrl(currentTeams.filter(function (value) { return value !== team; }), baseTags()));
      chip.setAttribute('data-fs-tag-nav', '');
      chip.setAttribute('data-fs-chip-value', team);
      chip.setAttribute('data-fs-chip-label', label);

      var x = template && template.querySelector('.fs-fdock__chip-x');
      chip.innerHTML =
        label +
        '<span class="fs-fdock__chip-x" aria-hidden="true">' +
        (x ? x.innerHTML : '') +
        '</span>' +
        '<span class="visually-hidden">Remove ' + label + ' filter</span>';

      if (clear) chips.insertBefore(chip, clear);
      else chips.appendChild(chip);
    });
  }

  function updateCount(total) {
    var count = document.getElementById('ProductCount');
    var all = count ? parseInt(count.getAttribute('data-total-count') || '', 10) : 0;
    if (!all && count) {
      var match = count.textContent.match(/of\s+([\d,]+)/i);
      if (match) all = parseInt(match[1].replace(/,/g, ''), 10);
    }

    var text = total.toLocaleString() + ' products';
    if (all && all > total) text = total.toLocaleString() + ' of ' + all.toLocaleString() + ' products';

    if (count) {
      count.textContent = text;
      count.setAttribute('data-product-count', String(total));
      if (all) count.setAttribute('data-total-count', String(all));
    }
    var desktop = document.getElementById('ProductCountDesktop');
    if (desktop) {
      desktop.textContent = text;
      desktop.setAttribute('data-product-count', String(total));
    }
    var result = dock.querySelector('[data-fs-fdock-result]');
    if (result) {
      var noun = dock.getAttribute('data-fs-fdock-noun') || 'jerseys';
      result.textContent = total.toLocaleString() + ' ' + noun;
    }
  }

  function parseCard(li) {
    var link = li.querySelector('a[href*="/products/"]');
    var handle = '';
    if (link) {
      var match = (link.getAttribute('href') || '').match(/\/products\/([^?"/]+)/);
      if (match) handle = match[1];
    }
    var heading = li.querySelector('.card__heading a, .card__heading');
    var price =
      li.querySelector('.price-item--sale') ||
      li.querySelector('.price-item--regular') ||
      li.querySelector('.price-item');
    var priceValue = 0;
    if (price) {
      var priceMatch = price.textContent.replace(/,/g, '').match(/([0-9]+(?:\.[0-9]+)?)/);
      if (priceMatch) priceValue = parseFloat(priceMatch[1]);
    }
    return {
      html: li.outerHTML,
      handle: handle || li.outerHTML.slice(0, 80),
      title: heading ? heading.textContent.trim() : '',
      price: priceValue,
    };
  }

  function mergeCards(lists, sort) {
    var merged = [];
    if (sort.indexOf('price-') === 0 || sort.indexOf('title-') === 0) {
      lists.forEach(function (list) { merged = merged.concat(list); });
      var descending = sort.indexOf('descending') !== -1;
      var priceSort = sort.indexOf('price-') === 0;
      merged.sort(function (a, b) {
        var av = priceSort ? a.price : a.title.toLowerCase();
        var bv = priceSort ? b.price : b.title.toLowerCase();
        if (av < bv) return descending ? 1 : -1;
        if (av > bv) return descending ? -1 : 1;
        return 0;
      });
    } else {
      var longest = 0;
      lists.forEach(function (list) { longest = Math.max(longest, list.length); });
      for (var i = 0; i < longest; i++) {
        lists.forEach(function (list) {
          if (list[i]) merged.push(list[i]);
        });
      }
    }

    var seen = {};
    return merged.filter(function (card) {
      if (seen[card.handle]) return false;
      seen[card.handle] = true;
      return true;
    });
  }

  function fetchTeamPage(team, page, tags, sort) {
    var cacheKey = team + '|' + page;
    if (cacheState.inFlight[cacheKey]) return cacheState.inFlight[cacheKey];
    var pathParts = [team].concat(tags);
    var url = collectionUrl + '/' + pathParts.map(encodeURIComponent).join('+');
    var params = new URLSearchParams();
    params.set('section_id', gridSectionId);
    if (page > 1) params.set('page', String(page));
    if (sort) params.set('sort_by', sort);
    url += '?' + params.toString();

    var request = fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var gridEl = doc.getElementById('product-grid');
        var cards = gridEl ? Array.prototype.map.call(gridEl.children, parseCard) : [];
        cacheState.pages[cacheKey] = cards;
        if (page === 1) {
          var countEl = doc.getElementById('ProductCount') || doc.getElementById('ProductCountDesktop');
          var count = countEl ? parseInt(countEl.getAttribute('data-product-count') || '0', 10) : 0;
          cacheState.counts[team] = isNaN(count) ? 0 : count;
        }
      })
      .catch(function () {
        cacheState.pages[cacheKey] = [];
        if (page === 1) cacheState.counts[team] = 0;
      });
    cacheState.inFlight[cacheKey] = request;
    return request;
  }

  function fetchPage(pageNumber) {
    if (!active()) return Promise.resolve('<ul id="product-grid"></ul>');
    if (!gridSectionId) return Promise.resolve('<ul id="product-grid"></ul>');

    var tags = baseTags();
    var sort = sortValue();
    var key = currentTeams.join(',') + '|' + tags.join('+') + '|' + sort;
    if (cacheState.key !== key) {
      cacheState = { key: key, pages: {}, counts: {}, inFlight: {} };
    }

    var requests = [];
    currentTeams.forEach(function (team) {
      for (var page = 1; page <= pageNumber; page++) {
        if (cacheState.pages[team + '|' + page]) continue;
        requests.push(fetchTeamPage(team, page, tags, sort));
      }
    });

    return Promise.all(requests).then(function () {
      var lists = currentTeams.map(function (team) {
        var cards = [];
        for (var page = 1; page <= pageNumber; page++) {
          cards = cards.concat(cacheState.pages[team + '|' + page] || []);
        }
        return cards;
      });

      var total = 0;
      currentTeams.forEach(function (team) {
        total += cacheState.counts[team] || 0;
      });
      window.FS.multiTeam.total = total;

      var merged = mergeCards(lists, sort);
      var start = (pageNumber - 1) * serverPer;
      var pageCards = merged.slice(start, start + serverPer);

      updateCount(total);
      var container = document.getElementById('ProductGridContainer');
      if (container) container.classList.remove('fs-mt-pending');
      window.requestAnimationFrame(function () {
        if (window.FS && window.FS.pagerRefresh) window.FS.pagerRefresh();
      });

      return (
        '<ul id="product-grid">' +
        pageCards.map(function (card) { return card.html; }).join('') +
        '</ul>'
      );
    });
  }

  function clearCache() {
    cacheState = { key: '', pages: {}, counts: {}, inFlight: {} };
  }

  window.FS = window.FS || {};
  window.FS.multiTeam = {
    active: active,
    total: 0,
    fetchPage: fetchPage,
    clearCache: clearCache,
  };

  /* Mark extra checked tiles / chips / tab counts from fs_teams. */
  if (active()) {
    markTiles();
    addExtraChips();
    var container = document.getElementById('ProductGridContainer');
    if (container) container.classList.add('fs-mt-pending');
  }

  /* Team checkboxes: full navigation keeps the URL shareable and avoids a
     half-merged grid. The pager handles the merged paging. */
  document.addEventListener('change', function (event) {
    var box = event.target.closest('[data-fs-team-toggle]');
    if (box) toggleTeam(box);
  });

  /* While two or more teams are selected, filter links must carry fs_teams
     across and reload so the merge starts cleanly. */
  document.addEventListener(
    'click',
    function (event) {
      if (!active()) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      var link = event.target.closest('[data-fs-tag-nav]');
      if (!link) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      handleFilterLink(link);
    },
    true
  );
})();
